import { useTranslation } from 'react-i18next';
import './Findus.css'

function Findus() {

    const { t } = useTranslation()

    return (
        <>
            <section className="container-lg p-0 d-flex justify-content-between align-items-center">
                <h2 className='heading'>{t("findus.title")}</h2>
                <hr className='heading-hr heading' />
            </section>
            <section className='container-lg findus-panel' id='section_4'>
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
                        <video controls className='h-100 w-100'>
                            <source src="videos/prezentacja.mp4" type="video/mp4" />
                        </video>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex flex-column justify-content-between align-items-center">
                        <div className='w-100 findus-panel__element' data-aos="fade-up" data-aos-delay="150">
                            <a href="https://www.youtube.com/watch?v=zknmfaYyma8" target='_blank' className='d-flex justify-content-start align-items-center w-100'>
                                <img src="icons/youtube.svg" alt="youtube" width={64} height={64} />
                                <div className="d-flex flex-column justify-content-start align-items-start h-100">
                                    <small className='mx-3 my-0'>Youtube:</small>
                                    <h5 className='mx-3 my-0'>Kam Tech</h5>
                                </div>
                            </a>
                        </div>
                        <div className='w-100 findus-panel__element' data-aos="fade-up" data-aos-delay="350">
                            <a href="https://www.instagram.com/kubickipiotr8/" target='_blank' className='d-flex justify-content-start align-items-center w-100'>
                                <img src="icons/instagram.svg" alt="instagram" width={64} height={64} />
                                <div className="d-flex flex-column justify-content-start align-items-start h-100">
                                    <small className='mx-3 my-0'>Instagram:</small>
                                    <h5 className='mx-3 my-0'>kubickipiotr8</h5>
                                </div>
                            </a>
                        </div>
                        <div className='w-100 findus-panel__element' data-aos="fade-up" data-aos-delay="550">
                            <a href="https://www.tiktok.com/@kubickipiotr?_t=8rfSYXlrwV4&_r=1" target='_blank' className='d-flex justify-content-start align-items-center w-100'>
                                <img src="icons/tiktok.svg" alt="Tiktok" width={64} height={64} />
                                <div className="d-flex flex-column justify-content-start align-items-start h-100">
                                    <small className='mx-3 my-0'>Tiktok:</small>
                                    <h5 className='mx-3 my-0'>kubickipiotr</h5>
                                </div>
                            </a>
                        </div>
                        <div className='w-100 findus-panel__element' data-aos="fade-up" data-aos-delay="750">
                            <a href="https://www.facebook.com/share/v/14TtYDV9BD/?mibextid=WC7FNe" target='_blank' className='d-flex justify-content-start align-items-center w-100'>
                                <img src="icons/facebook.svg" alt="Facebook" width={64} height={64} />
                                <div className="d-flex flex-column justify-content-start align-items-start h-100">
                                    <small className='mx-3 my-0'>Facebook:</small>
                                    <h5 className='mx-3 my-0'>Kam-Tech Kamieniarstwo</h5>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );

}


export default Findus